// src/components/auth/SignUp/validationRules.js
import i18n from "i18next";

const { t } = i18n;

export const VALIDATION_RULES = {
  email: {
    required: t("email_required"),
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: t("invalid_email"),
    },
  },
  phone: {
    required: t("phone_required"),
    pattern: {
      value: /^[+]?[\d\s\-().]{6,20}$/,
      message: t("invalid_phone"),
    },
  },
  website: {
    pattern: {
      value: /^(https?:\/\/)?([a-zA-Z][a-zA-Z0-9-]*\.)+[a-zA-Z]{2,}(\/\S*)?$/,
      message: t("invalid_website"),
    },
  },
  password: {
    required: t("password_required"),
    minLength: {
      value: 8,
      message: t("password_min"),
    },
  },
  postal_code: {
    required: t("postal_required"),
    pattern: {
      value: /^[0-9]{5,}$/,
      message: t("postal_invalid"),
    },
  },
};
